import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $, nothing as w } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { classMap as o } from '../../../../node_modules/lit-html/directives/class-map.js';
import '../../../../node_modules/lit-media-query/lit-media-query.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import img$2 from '../../../../assets/images/cross-icon.svg.js';
import img$1 from '../../../../assets/images/mob-menu-trigger.svg.js';
import img from '../../../../assets/images/login-menu-trigger.svg.js';
import '../../atoms/buttons/icon-button/index.js';
import { disableBodyScroll, enableBodyScroll, debounce, triggerExternalLinkPopup } from '../../utilities/behavior-helpers/index.js';
import { isRTL } from '../../utilities/dom-helpers/index.js';
import './main-nav-mobile.js';
import './login-menu.js';
import css_248z from './main-nav.scss.js';
import './sub-nav.js';

function getShift(el1, el2) {
    return Math.ceil(el1.getBoundingClientRect().top - el2.getBoundingClientRect().height);
}
// @ts-ignore
class MainNav extends s {
    constructor() {
        super(...arguments);
        this.rtl = false;
        this.menuLogo = 'Logo';
        this.siteName = 'logo-mobile';
        this.backText = 'Back';
        this.forwardText = 'Go to';
        this.closeButtonText = 'Close Menu';
        this.openMenuText = 'Open Menu';
        this.goToHomePageText = 'Go to Homepage';
        this.rootUrl = '';
        this.showSignInButton = false;
        this.useSimpleNavigation = false;
        this.loginMenuIsOpen = false;
        this.mobileMenuIsOpen = false;
        this.submenuIsClosing = false;
        this.activeMenuItem = null;
        this.query = '(max-width: 1023px)';
        this.externalLinkPopup = null;
        this.isMobile = false;
        this.isAuthorized = false;
        this.header = null;
        this.alertBanner = null;
        this.alertBannerInner = null;
        this.heroBlock = null;
        this.pusher = null;
        this.breadcrumb = null;
        this.content = null;
        this.top = null;
        this.loginButtonsSlot = null;
        this.focusedElement = null;
        this.isAuthenticated = false;
        this.loginType = 'none';
        this.userName = '';
        this.avatarUrl = '';
        this.loginUrl = '';
        this.registerUrl = '';
        this.logoutUrl = '';
        this.accountManagementUrl = '';
        this.accountManagementText = '';
        this.loginButtonText = '';
        this.registerButtonText = '';
        this.logoutButtonText = '';
        this.disabled = false;
        this.setNegativeMargin = (shift) => {
            this.top.style.top = shift < 0 ? `${shift}px` : '0px';
        };
        this.handleScroll = () => {
            var _a;
            if (!this.pusher)
                return;
            const mainMenu = this.shadowRoot.querySelector('nav');
            const shift = getShift(this.pusher, this.top);
            if (shift > -this.top.offsetHeight && shift < 0) {
                this.setNegativeMargin(shift);
            }
            else {
                this.top.style.top = '';
            }
            if (this.top.offsetHeight + shift <= 0) {
                mainMenu.classList.add('condensed');
                this.top.classList.add('sticky');
                setTimeout(() => {
                    var _a;
                    this.top.classList.add('reveal');
                    if (this.isMobile) {
                        (_a = this.alertBannerInner) === null || _a === void 0 ? void 0 : _a.classList.add('hide-on-scroll');
                    }
                }, 10);
                return;
            }
            if (this.top.offsetHeight + shift > 0) {
                this.top.classList.remove('reveal');
                mainMenu.classList.remove('condensed');
                this.top.classList.remove('sticky');
                if (this.isMobile) {
                    (_a = this.alertBannerInner) === null || _a === void 0 ? void 0 : _a.classList.remove('hide-on-scroll');
                }
            }
        };
        this.updated = () => {
            if (this.activeMenuItem) {
                disableBodyScroll();
            }
            else {
                enableBodyScroll();
            }
        };
        this.firstUpdated = () => {
            setTimeout(() => {
                this.header = document.querySelector('header');
                this.content = document.querySelector('.content');
                this.top = document.querySelector('.top');
                this.heroBlock = document.querySelector('full-image-video');
                if (this.top && this.content && this.heroBlock) {
                    this.requestUpdate();
                }
                this.pusher = this.heroBlock
                    ? this.heroBlock.shadowRoot.querySelector('.after')
                    : this.content;
                this.hideSearchBtnText();
            }, 0);
            this.setButtonsWidthVar();
            const modal = document.querySelector('cvt-modal[popupid="external-link"]');
            if (!modal)
                return;
            this.externalLinkPopup = modal.querySelector('external-link');
        };
    }
    toggleLoginMenu() {
        var _a, _b;
        const loginStatus = (_a = this.shadowRoot.querySelector('slot[name="login-status"]')) === null || _a === void 0 ? void 0 : _a.assignedElements()[0];
        const authHref = (_b = this.shadowRoot.querySelector('slot[name="auth-href"]')) === null || _b === void 0 ? void 0 : _b.assignedElements()[0];
        if ((loginStatus === null || loginStatus === void 0 ? void 0 : loginStatus.innerHTML.toLocaleLowerCase()) === 'true') {
            this.isAuthorized = true;
        }
        if (!this.isAuthorized && (authHref === null || authHref === void 0 ? void 0 : authHref.innerHTML.length)) {
            window.location.href = authHref.innerHTML;
            return;
        }
        this.loginMenuIsOpen = !this.loginMenuIsOpen;
        if (this.loginMenuIsOpen) {
            disableBodyScroll();
        }
        else {
            enableBodyScroll();
        }
    }
    static toggleSearchBar(show) {
        const searchBar = document.querySelector('search-bar');
        if (searchBar)
            searchBar.style.display = show ? 'flex' : 'none';
    }
    toggleMobileMenu() {
        this.mobileMenuIsOpen = !this.mobileMenuIsOpen;
        if (this.mobileMenuIsOpen) {
            disableBodyScroll();
            MainNav.toggleSearchBar(false);
        }
        else {
            enableBodyScroll();
            MainNav.toggleSearchBar(true);
        }
    }
    stealFocus() {
        setTimeout(() => {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            const closeButton = (_b = (_a = this.renderRoot
                .querySelector('.modal-container icon-button')) === null || _a === void 0 ? void 0 : _a.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector('button');
            const topLink = (_d = (_c = this.renderRoot
                .querySelector('sub-nav')) === null || _c === void 0 ? void 0 : _c.shadowRoot) === null || _d === void 0 ? void 0 : _d.querySelector('.root-page-link');
            const lvl2Links = (_f = (_e = this.renderRoot
                .querySelector('sub-nav')) === null || _e === void 0 ? void 0 : _e.shadowRoot) === null || _f === void 0 ? void 0 : _f.querySelectorAll('.leaf');
            const holder = (_h = (_g = this.renderRoot
                .querySelector('sub-nav')) === null || _g === void 0 ? void 0 : _g.shadowRoot) === null || _h === void 0 ? void 0 : _h.querySelector('.holder');
            if (lvl2Links) {
                // scroll the holder to the bottom when the last link is reached (Firefox specific)
                lvl2Links[lvl2Links.length - 1].addEventListener('focus', () => {
                    holder.scrollTop = holder.scrollHeight;
                });
                // set focus to close button when last link is tabbed
                lvl2Links[lvl2Links.length - 1].addEventListener('blur', () => {
                    closeButton === null || closeButton === void 0 ? void 0 : closeButton.focus();
                });
            }
            topLink === null || topLink === void 0 ? void 0 : topLink.focus();
        }, 200);
    }
    setActiveBranch(branch) {
        this.activeMenuItem = branch;
        this.stealFocus();
    }
    handleSubmenuClose(setFocus = false) {
        this.submenuIsClosing = true;
        setTimeout(() => {
            var _a;
            this.activeMenuItem = null;
            this.submenuIsClosing = false;
            if (setFocus)
                (_a = this.focusedElement) === null || _a === void 0 ? void 0 : _a.focus();
        }, 300);
    }
    connectedCallback() {
        super.connectedCallback();
        setTimeout(() => {
            this.alertBanner = document.querySelector('alert-banner');
            if (this.alertBanner) {
                this.alertBannerInner = this.alertBanner.shadowRoot.querySelector('.alert-banner__container');
            }
        }, 0);
        window.addEventListener('scroll', debounce(() => {
            this.handleScroll();
        }, 100));
    }
    disconnectedCallback() {
        window.removeEventListener('scroll', this.handleScroll);
        super.disconnectedCallback();
    }
    setButtonsWidthVar() {
        const buttonEl = this.shadowRoot.querySelector('.button');
        setTimeout(() => {
            const width = buttonEl === null || buttonEl === void 0 ? void 0 : buttonEl.offsetWidth;
            this.style.setProperty('--buttonswidth', `${width}px`);
        }, 0);
    }
    hideSearchBtnText() {
        var _a, _b;
        // hiding text of search button if there are any additional buttons in navigation
        this.loginButtonsSlot = this.shadowRoot.querySelector('slot[name=login-buttons-desktop]');
        const searchButtonSlot = this.shadowRoot.querySelector('slot[name=search]');
        const searchButtonText = (_a = searchButtonSlot === null || searchButtonSlot === void 0 ? void 0 : searchButtonSlot.assignedElements()[0]) === null || _a === void 0 ? void 0 : _a.shadowRoot.querySelector('button span');
        if (!searchButtonText)
            return;
        if (((_b = this.loginButtonsSlot) === null || _b === void 0 ? void 0 : _b.assignedElements().length) > 0) {
            searchButtonText.style.display = 'none';
        }
        window.addEventListener('resize', () => {
            if (!this.loginButtonsSlot)
                this.loginButtonsSlot = this.shadowRoot.querySelector('slot[name=login-buttons-desktop]');
            if (!this.loginButtonsSlot)
                return;
            if (!this.loginButtonsSlot.assignedElements().length) {
                searchButtonText.style.display = 'block';
            }
            else {
                searchButtonText.style.display = 'none';
            }
        });
    }
    setFocusedElement(href) {
        const element = this.shadowRoot.querySelector(`a[href="${href}"]`);
        if (element)
            this.focusedElement = element;
    }
    renderMainNavLinks() {
        return this.useSimpleNavigation
            ? null
            : this.data.map(branch => {
                const isActive = branch.active ? 'active' : null;
                return branch.items.length > 0
                    ? $ `<li><a class="main-nav-link ${isActive}" href="${branch.link}" role="button" tabindex="0" @click="${(e) => {
                        e.preventDefault();
                        this.setFocusedElement(branch.link);
                        this.setActiveBranch(branch);
                    }}"><span class="link-text">${branch.title}</span></a></li>`
                    : $ `<li><a role="button" tabindex="0" class="main-nav-link ${isActive}" @click="${(e) => triggerExternalLinkPopup(e, this)}" href="${branch.link}"><span class="link-text">${branch.title}</span></a></li>`;
            });
    }
    renderSubNav() {
        return this.activeMenuItem
            ? $ `<sub-nav ?rtl="${this.rtl || isRTL()}" menuLogo="${this.menuLogo}" .data="${this.activeMenuItem}" @click="${this.handleSubmenuClose}" @keydown="${(e) => e.key === 'Escape' && this.handleSubmenuClose(true)}"></sub-nav>`
            : null;
    }
    handleMediaQuery(e) {
        this.isMobile = e.detail.value;
    }
    handleCloseBtnPress(e) {
        if (e.key === 'Escape' || e.key === 'Enter') {
            this.handleSubmenuClose(true);
        }
        const shift = e.shiftKey;
        const { activeElement } = document;
        if (e.key === 'Tab' && shift && activeElement === this) {
            e.preventDefault();
        }
    }
    renderLoginMenuTrigger() {
        return !this.useSimpleNavigation &&
            this.isMobile &&
            (this.showSignInButton || this.loginType === 'signinbutton')
            ? $ `<button class="login-menu-trigger" @click="${() => this.toggleLoginMenu()}" aria-label="${this.openMenuText}"><img loading="lazy" alt="" src="${img}"></button>`
            : null;
    }
    renderLoginMenu() {
        const showLoginButtons = !this.loginType || this.loginType === 'signinbutton';
        let loginButtonsSlot = w;
        if (showLoginButtons) {
            loginButtonsSlot = $ `<slot name="login-buttons" slot="login-buttons"></slot>`;
        }
        return this.isMobile
            ? $ `<login-menu ?open="${this.loginMenuIsOpen}" .onClose="${() => this.toggleLoginMenu()}" gotoHomePageText="${this.goToHomePageText}" closeButtonText="${this.closeButtonText}"><slot name="login-status"></slot><slot name="auth-href"></slot><slot name="login-menu-logo" slot="login-menu-logo"></slot><slot name="login-menu-heading" slot="login-menu-heading"></slot><slot name="login-menu-description" slot="login-menu-description"></slot>${loginButtonsSlot}</login-menu>`
            : null;
    }
    renderMobileMenuTrigger() {
        return !this.useSimpleNavigation && this.isMobile
            ? $ `<button class="mobile-menu-trigger" @click="${() => this.toggleMobileMenu()}" aria-label="${this.openMenuText}" aria-expanded="${this.mobileMenuIsOpen ? 'true' : 'false'}"><img loading="lazy" alt="" aria-hidden="true" src="${img$1}"></button>`
            : null;
    }
    renderDesktopButtons() {
        const showLoginButtonsDesktop = !this.loginType || this.loginType === 'signinbutton';
        let loginButtonsDesktopSlot = null;
        if (showLoginButtonsDesktop) {
            loginButtonsDesktopSlot = $ `<slot name="login-buttons-desktop"></slot>`;
        }
        return !this.isMobile
            ? $ `<div class="button">${loginButtonsDesktopSlot}<slot name="search"></slot></div>`
            : null;
    }
    renderNavigation() {
        return this.isMobile
            ? $ `<main-nav-mobile ?rtl="${this.rtl || isRTL()}" ?open="${this.mobileMenuIsOpen}" .backText="${this.backText}" .forwardText="${this.forwardText}" .closeButtonText="${this.closeButtonText}" .data="${this.data}" .onClose="${() => this.toggleMobileMenu()}" .isAuthenticated="${this.isAuthenticated}" .loginType="${this.loginType}" .userName="${this.userName}" .avatarUrl="${this.avatarUrl}" .loginUrl="${this.loginUrl}" .registerUrl="${this.registerUrl}" .logoutUrl="${this.logoutUrl}" .accountManagementUrl="${this.accountManagementUrl}" .accountManagementText="${this.accountManagementText}" .loginButtonText="${this.loginButtonText}" .registerButtonText="${this.registerButtonText}" .logoutButtonText="${this.logoutButtonText}" ?disabled="${this.disabled}"><slot name="logo-mobile" slot="logo-mobile"></slot><slot name="global-nav" slot="global-nav"></slot><slot name="search" slot="button"></slot></main-nav-mobile>`
            : $ `<ul class="${o({
                links: true,
                rtl: this.rtl || isRTL(),
                'mobile-links-open': this.mobileMenuIsOpen,
            })}">${this.renderMainNavLinks()}</ul>`;
    }
    renderMobileHeader() {
        return $ `<div class="mobile-header">${this.renderMobileMenuTrigger()}<slot name="search"></slot></div>`;
    }
    renderPrimaryNav() {
        if (this.isMobile) {
            return $ `<div><a href="${this.rootUrl}" aria-label="${this.siteName}"><slot name="logo-tablet" class="logo-tablet"></slot></a></div><div class="primary-nav">${this.renderMobileHeader()} ${this.renderNavigation()}</div>`;
        }
        return $ `<div class="icon-responsive"><a href="${this.rootUrl}" aria-label="${this.siteName}"><slot name="logo"></slot></a></div><div class="primary-nav">${this.renderNavigation()}</div>${this.renderDesktopButtons()}`;
    }
    render() {
        const modalClassMap = {
            'modal-container': true,
            rtl: this.rtl || isRTL(),
            open: !!this.activeMenuItem,
            closing: this.submenuIsClosing,
        };
        return $ `<nav id="main-nav" aria-label="navigation"><div class="${o({
            rtl: this.rtl || isRTL(),
            'main-nav-container': true,
        })}">${this.renderPrimaryNav()} ${this.renderLoginMenu()} ${this.renderLoginMenuTrigger()}<div class="${o(modalClassMap)}" @keydown="${(e) => e.key === 'Escape' && this.handleSubmenuClose(true)}"><div class="modal-inner"><icon-button class="close-button" .onClick="${() => this.handleSubmenuClose()}" @keydown="${(e) => this.handleCloseBtnPress(e)}" ariaLabel="${this.closeButtonText}"><img slot="icon" src="${img$2}" alt="" aria-hidden="true"></icon-button>${this.renderSubNav()}</div></div></div></nav><lit-media-query .query="${this.query}" @changed="${this.handleMediaQuery}"></lit-media-query>`;
    }
}
MainNav.styles = css_248z;
__decorate([
    e({ type: Boolean })
], MainNav.prototype, "rtl", void 0);
__decorate([
    e()
], MainNav.prototype, "menuLogo", void 0);
__decorate([
    e()
], MainNav.prototype, "siteName", void 0);
__decorate([
    e()
], MainNav.prototype, "backText", void 0);
__decorate([
    e()
], MainNav.prototype, "forwardText", void 0);
__decorate([
    e()
], MainNav.prototype, "closeButtonText", void 0);
__decorate([
    e()
], MainNav.prototype, "openMenuText", void 0);
__decorate([
    e()
], MainNav.prototype, "goToHomePageText", void 0);
__decorate([
    e()
], MainNav.prototype, "rootUrl", void 0);
__decorate([
    e({ type: Boolean })
], MainNav.prototype, "showSignInButton", void 0);
__decorate([
    e({ type: Object })
], MainNav.prototype, "data", void 0);
__decorate([
    e({ type: Boolean })
], MainNav.prototype, "useSimpleNavigation", void 0);
__decorate([
    t()
], MainNav.prototype, "loginMenuIsOpen", void 0);
__decorate([
    t()
], MainNav.prototype, "mobileMenuIsOpen", void 0);
__decorate([
    t()
], MainNav.prototype, "submenuIsClosing", void 0);
__decorate([
    t()
], MainNav.prototype, "activeMenuItem", void 0);
__decorate([
    e({ type: String })
], MainNav.prototype, "query", void 0);
__decorate([
    t()
], MainNav.prototype, "externalLinkPopup", void 0);
__decorate([
    t()
], MainNav.prototype, "isMobile", void 0);
__decorate([
    e({
        type: Boolean,
        converter: {
            fromAttribute: (value) => value === 'true',
            toAttribute: (value) => (value ? 'true' : 'false'),
        },
    })
], MainNav.prototype, "isAuthenticated", void 0);
__decorate([
    e({ type: String })
], MainNav.prototype, "loginType", void 0);
__decorate([
    e({ type: String })
], MainNav.prototype, "userName", void 0);
__decorate([
    e({ type: String })
], MainNav.prototype, "avatarUrl", void 0);
__decorate([
    e({ type: String })
], MainNav.prototype, "loginUrl", void 0);
__decorate([
    e({ type: String })
], MainNav.prototype, "registerUrl", void 0);
__decorate([
    e({ type: String })
], MainNav.prototype, "logoutUrl", void 0);
__decorate([
    e({ type: String })
], MainNav.prototype, "accountManagementUrl", void 0);
__decorate([
    e({ type: String })
], MainNav.prototype, "accountManagementText", void 0);
__decorate([
    e({ type: String })
], MainNav.prototype, "loginButtonText", void 0);
__decorate([
    e({ type: String })
], MainNav.prototype, "registerButtonText", void 0);
__decorate([
    e({ type: String })
], MainNav.prototype, "logoutButtonText", void 0);
__decorate([
    e({ type: Boolean })
], MainNav.prototype, "disabled", void 0);
customElements.define('main-nav', MainNav);

export { MainNav };
